<div class="h-full overflow-hidden">
  <p-scroll-panel class="h-full">
    <form [formGroup]="form">
      <div class="control">
        <label>Letsikring nr</label>
        <input pInputText formControlName="letsikringNr" />
      </div>
      <div class="control">
        <label>Revision</label>
        <input pInputText formControlName="revisionNr" />
      </div>
      <div class="control">
        <label>Hændelseskode</label>
        <input pInputText formControlName="haendelsesKode" />
      </div>
      <div class="control">
        <label>Produkt type</label>
        <p-select
          [options]="produktTypeService.produktTypeOptions()"
          [showClear]="true"
          formControlName="produktType"
          appendTo="body" />
      </div>
      <div class="control">
        <label>Regnr</label>
        <input pInputText formControlName="regnr" />
      </div>
      <div class="control">
        <label>CPR nr</label>
        <app-let-input-cpr formControlName="cprNummer" />
      </div>
      <div class="control">
        <label>Reference</label>
        <input pInputText formControlName="reference" />
      </div>
      <div class="control">
        <label>Opkrævningstype</label>
        <p-select
          [options]="opkraevningsTypeOptions"
          [showClear]="true"
          formControlName="opkraevningsType"
          optionLabel="text"
          optionValue="value"
          appendTo="body" />
      </div>
      <div class="control">
        <label>Opkrævningsstatus</label>
        <p-select
          [options]="opkraevningsStatusOptions"
          [showClear]="true"
          formControlName="opkraevningsStatus"
          optionLabel="text"
          optionValue="value"
          appendTo="body" />
      </div>

      <div class="flex gap-2">
        <p-button
          label="Søg"
          (click)="onClickSearch()"
          [loading]="opkraevningService.datasource.isLoading()"
          icon="pi pi-search"
          type="submit" />
        <p-button
          label="Nulstil"
          (click)="onClickReset()"
          icon="pi pi-times"
          severity="secondary"
          outlined />
      </div>
    </form>
    @if (noHits()) {
      <p-message text="Ingen hits" severity="error" styleClass="mt-4" />
    }
  </p-scroll-panel>
</div>
